import { PYTHON_SERVICE_ENDPOINTS, PythonAPI } from '@buildwise/libs/services';
import { InsightSummaryPayload } from './InsightsAPI';

export type InsightFilterType = {
  filterName: string;
  filterValues: string[];
};

export type InsightSummarySearchPayload = InsightSummaryPayload & {
  novaSearchKeyWord: string;
};

export enum InsightType {
  MasterFormat = 'MasterFormat',
  UniFormat = 'UniFormat',
}

class PythonInsightsAPI extends PythonAPI {
  public getInsightsSearch(payload: {
    companyId: string;
    filters?: InsightFilterType[];
    groupBy: string;
    includeBWInsights: boolean;
    novaSearchKeyWord: string;
  }) {
    return this.post(PYTHON_SERVICE_ENDPOINTS.GET_INSIGHTS_SEARCH, payload);
  }

  public getInsightsSummarySearch(payload: InsightSummarySearchPayload) {
    return this.post(PYTHON_SERVICE_ENDPOINTS.GET_INSIGHTS_SUMMARY_SEARCH, payload);
  }
}

const pythonInsightsAPI = new PythonInsightsAPI();
export default pythonInsightsAPI;
